function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.97 13.03h11.09v-1.41h1.11v2.53H4.08v2.58L0 13.57V3.62h1.94v1.1H1.1v8.25l1.87 1.45v-1.43zM7.6 6.28a1.06 1.06 0 01-.75-.27.91.91 0 01-.29-.7.92.92 0 01.3-.71 1.16 1.16 0 011.49 0 .92.92 0 01.3.71.91.91 0 01-.29.7 1.07 1.07 0 01-.75.27m3.8 0a1.06 1.06 0 01-.75-.27.91.91 0 01-.29-.7.92.92 0 01.3-.71 1.16 1.16 0 011.49 0 .92.92 0 01.3.71.91.91 0 01-.29.7 1.07 1.07 0 01-.75.27m3.8 0a1.06 1.06 0 01-.75-.27.91.91 0 01-.29-.7.92.92 0 01.3-.71 1.16 1.16 0 011.49 0 .92.92 0 01.3.71.91.91 0 01-.29.7 1.07 1.07 0 01-.75.27m4.13-5.19H4.16v8.27h13.3v1.43l1.87-1.45V1.09zm-3 12v-2.58H3.06V0H20.4v9.89z"
});

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 20.43 16.72"
  }, props), _ref);
};

export default SvgChat;